import { useIntl } from "react-intl";
import { forwardRef, HTMLAttributes, useCallback } from "react";
import { classNames } from "@ct-react/core";
import { AgeCategory } from "@shared/graphql";
import { common, form } from "../../../i18n/sharable-defs";
import SpriteIcon from "../../medias/sprite-icon";
import "./guests.scss";
import { IconEdit } from "@tabler/icons-react";

type Props = HTMLAttributes<HTMLDivElement> & {
  withIcon?: boolean;
  value?: Record<AgeCategory, number>
};

const GuestsResumeInput = forwardRef<HTMLDivElement, Props>(({ className, withIcon = false, value, ...props }, forwardedRef) => {

  const intl = useIntl();

  const format = useCallback((guests?: Record<AgeCategory, number>): string => {
    const count = Object.values(guests || {}).reduce((acc, val) => acc + val, 0);
    return count > 0 ? intl.formatMessage(common.countedGuests, { count }) : "";
  }, [ value, intl ]);

  const wrapperClasses = classNames("fi-group", "guests-input", className, { "with-icon": withIcon });

  return (
    <div ref={forwardedRef}
         className={wrapperClasses}
         {...props}>
      <SpriteIcon hash="features.person" className="i-icon" width={22} />
      <label htmlFor="guests">{intl.formatMessage(form.guests)}</label>
      <input type="text" id="guests"
             placeholder={intl.formatMessage(form.guestsPlaceholder)} readOnly
             value={format(value)} />
      {withIcon && <IconEdit className="e-icon" />}
    </div>);

});

export default GuestsResumeInput;
